import React, { useEffect, useState, useMemo } from "react";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";
import isEqual from "lodash/isEqual";

//redux
import { useDispatch } from "react-redux";
import * as auth from "../modules/auth/redux/AuthRedux";

type FunctionType = (data: any) => Promise<AxiosResponse<any>>;

export const useFetchTableData = (
  apiCall: FunctionType,
  showField: number,
  currentPage: number,
  query: any = {},
  actionCallId: number = 0
) => {
  const [fetchResult, setFetchResult] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const [previousQuery, setPreviousQuery] = useState<any>({});
  const [isQueryChange, setIsQueryChange] = useState<boolean>(false);

  const dispatch = useDispatch();

  if (!isEqual(query, previousQuery)) {
    setPreviousQuery(query);
    setIsQueryChange(true);
    setLoading(true);
  }

  useEffect(() => {
    setTimeout(() => {
      const getData = async () => {
        setError("");
        const SearchQuery = {
          ...query,
          limit: showField,
          offset: (currentPage - 1) * showField,
        };
        //  console.log(SearchQuery)
        try {
          const response = await apiCall(SearchQuery);
          if (response.status === 200) {
            // console.log(response);
            setFetchResult(response);
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: `${response?.data?.message}`,
              showConfirmButton: false,
              timer: 1000,
            });
          }
        } catch (error: any) {
          if (error?.response && error?.response?.status === 401) {
            // Handle unauthorized error here, such as redirecting to login page
            Swal.fire({
              position: "center",
              icon: "error",
              title: `${error.response?.data?.message}`,
              showConfirmButton: false,
              timer: 1000,
            });
            dispatch(auth?.actions.logout());
          } else {
            // Handle others error
            Swal.fire({
              position: "center",
              icon: "error",
              title: `${error.response?.data?.message}`,
              showConfirmButton: false,
              timer: 1000,
            });
          }
          setError("Error Occurred");
        } finally {
          setLoading(false);
          setIsQueryChange(false);
        }
      };
      getData();
    }, 200);
  }, [showField, currentPage, actionCallId, isQueryChange]);

  return [fetchResult, loading, error];
};
